import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import { Box, ThemeProvider } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';
import { useQuery } from '@apollo/client';
import { UserQueries } from './models/user';
import { Helmet } from 'react-helmet';

const App = () => {
  const { data: { me } = {}, loading } = useQuery(UserQueries.fetchMe, {
    fetchPolicy: 'network-only',
  });
  const isAuthenticated = Boolean(me?._id);
  console.log({ isAuthenticated });
  const routing = useRoutes(routes({ isAuthenticated }));

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />

      {loading ? (
        <Box
          sx={{
            backgroundColor: 'background.default',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={55} />
        </Box>
      ) : (
        routing
      )}
    </ThemeProvider>
  );
};

export default App;
